import PictureCardPictureTypesDownload from './PictureCardPictureTypesDownload'
export default PictureCardPictureTypesDownload
